import CartQuickView from './CartQuickView';

export { CartQuickView };
export default CartQuickView;
